/**
 *
 * @/services/groups.js
 *
 */

//
// IMPORTS
//

// import { httpPost } from "@/services/api/http"
import { sosApi, httpRequest } from "@/services/api"
// import { getUserUID } from "@/services/endpoints/session"
import { testFbId } from "@/services"
import { apiUrl, /* version, PARTNER */ } from "@/constants"

//
//
//

export const getGroupUsersCount = async ({ groupID }) => {
  const response = await sosApi.get(`v1/groups/${groupID}/users/count`)

  if (response.title === 'error' || !response.data) {
    throw new Error(response.message || 'Erro ao carregar quantidade de usuários do grupo')
  }

  return response
}

//
//
//
// Consulta ID DO CONVITE de um grupo
//
//
//

const getGroupInviteId = async groupID => {
  const request = await testFbId.ref(`grupos/${groupID}/idconvite`).once('value')
  return request && request.val() ? String(request.val()) : ''
}

//
//
//
// Consulta GRUPO através do ID
//
//
//

const getGroup = async groupID => {
  const request = await testFbId.ref(`grupos/${groupID}`).once('value')
  return request && request.val() ? request.val() : false
}

//
//
//
// Entrar no grupo
//
//
//

const apiJoinGroup = async (userID, groupID) => {
  const updates = {}
  updates['grupos/' + groupID + '/users/' + userID] = { admin: false, enablePush: true }
  updates['users/' + userID + '/grupos/' + groupID] = { admin: false, enablePush: true }

  //
  // Executa operações no banco de dados
  //

  return new Promise((resolve, reject) => {
    try
    {
      testFbId.ref().update(updates,
      error => {
        if (error) {
          resolve({
            code: 0,
            message: 'Não foi possível entrar no grupo. Por favor, tente novamente ou fale com o nosso suporte.',
          })
        } else {
          resolve({
            code: 1,
            message: '',
          })
        }
      })
    }
    catch (e)
    {
      resolve({
        code: 0,
        message: 'Não foi possível entrar no grupo. Por favor, tente novamente ou fale com o nosso suporte.',
      })
    }
  })
}


// Atualiza a ordem das escalas
const apiUpdateScaleOrder = async (groupID, newOrder, token) => {
  try {

    const response = await httpRequest({
      method: 'PUT',
      url: `${apiUrl}/scales/reorder`,
      payload: {
        group_id: groupID,
        scale_ids: newOrder,
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });



    if (response.code >= 400) {
      throw new Error(response.message || 'Erro ao atualizar a ordem das escalas.');
    }

    return {
      code: 1,
      message: response.message || 'Ordem atualizada com sucesso.',
      data: response.data,
    };
  } catch (error) {
    console.error('Erro na chamada da API para reordenar escalas:', error);
    return {
      code: 0,
      message: error.message || 'Não foi possível atualizar a ordem das escalas. Por favor, tente novamente.',
    };
  }
};

// Retorna a ordem personalizada das escalas para um usuário em um grupo
const apiGetUserScaleOrder = async (groupID, token) => {

  try {
    console.log('Chamando apiGetUserScaleOrder com groupID:', groupID);
    const response = await httpRequest({
      method: 'GET',
      url: `${apiUrl}/scales/order/${groupID}`,
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (response.code >= 400) {
      throw new Error(response.message || 'Erro ao buscar a ordem das escalas.');
    }

    return {
      code: 1,
      message: response.message || 'Ordem das escalas recuperada com sucesso.',
      data: response.data,
    };
  } catch (error) {
    console.error('Erro na chamada da API para buscar a ordem das escalas:', error);
    return {
      code: 0,
      message: error.message || 'Não foi possível buscar a ordem das escalas. Por favor, tente novamente.',
    };
  }
};

// SAÍDA
//
//
//
// SAÍDA
//
//
//

export {
  getGroupInviteId,
  getGroup,
  apiJoinGroup,
  apiUpdateScaleOrder,
  apiGetUserScaleOrder
}
